import React, {Component} from "react";
import PropTypes from "prop-types";
import PhaseModel from "../models/phase";
import Octicon, {Trashcan} from "@github/octicons-react";

export default class PhaseListItem extends Component {
    render() {
        let className = this.props.isActive ? 'list-group-item active' : 'list-group-item';
        return (
            <li className={className} onClick={() => this.props.onClick(this.props.model.id)}>
                {this.props.model.id}, {this.props.model.name}, {this.props.model.shortName}
                <button onClick={() => this.props.onDelete(this.props.model.id)} type="button" className="btn btn-outline-danger btn-sm float-right"><Octicon icon={Trashcan}/></button>
            </li>
        )
    }
}

PhaseListItem.propTypes = {
    model: PropTypes.instanceOf(PhaseModel).isRequired,
    isActive: PropTypes.bool,
    onClick: PropTypes.func,
    onDelete: PropTypes.func
};

PhaseListItem.defaultProps = {
    onClick: () => {},
    onDelete: () => {alert('no function defined for onDelete')}
};



// WEBPACK FOOTER //
// ./src/components/PhaseListItem.js